/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SMRuleListQuery
 */
export interface SMRuleListQuery {
    /**
     * 
     * @type {boolean}
     * @memberof SMRuleListQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SMRuleListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {number}
     * @memberof SMRuleListQuery
     */
    distributionChannel?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SMRuleListQuery
     */
    agency?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SMRuleListQuery
     */
    agencyOnly?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SMRuleListQuery
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SMRuleListQuery
     */
    relevance?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SMRuleListQuery
     */
    origin?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SMRuleListQuery
     */
    originIsCityCode?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SMRuleListQuery
     */
    destination?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SMRuleListQuery
     */
    destinationIsCityCode?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SMRuleListQuery
     */
    supplier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SMRuleListQuery
     */
    carrier?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SMRuleListQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SMRuleListQuery
     */
    orderByRelevanceAscending?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SMRuleListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SMRuleListQuery
     */
    limit?: number | null;
}

export function SMRuleListQueryFromJSON(json: any): SMRuleListQuery {
    return SMRuleListQueryFromJSONTyped(json, false);
}

export function SMRuleListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMRuleListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : json['distributionChannel'],
        'agency': !exists(json, 'agency') ? undefined : json['agency'],
        'agencyOnly': !exists(json, 'agencyOnly') ? undefined : json['agencyOnly'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'origin': !exists(json, 'origin') ? undefined : json['origin'],
        'originIsCityCode': !exists(json, 'originIsCityCode') ? undefined : json['originIsCityCode'],
        'destination': !exists(json, 'destination') ? undefined : json['destination'],
        'destinationIsCityCode': !exists(json, 'destinationIsCityCode') ? undefined : json['destinationIsCityCode'],
        'supplier': !exists(json, 'supplier') ? undefined : json['supplier'],
        'carrier': !exists(json, 'carrier') ? undefined : json['carrier'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'orderByRelevanceAscending': !exists(json, 'orderByRelevanceAscending') ? undefined : json['orderByRelevanceAscending'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function SMRuleListQueryToJSON(value?: SMRuleListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showDisabled': value.showDisabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': value.distributionChannel,
        'agency': value.agency,
        'agencyOnly': value.agencyOnly,
        'description': value.description,
        'relevance': value.relevance,
        'origin': value.origin,
        'originIsCityCode': value.originIsCityCode,
        'destination': value.destination,
        'destinationIsCityCode': value.destinationIsCityCode,
        'supplier': value.supplier,
        'carrier': value.carrier,
        'showDeleted': value.showDeleted,
        'orderByRelevanceAscending': value.orderByRelevanceAscending,
        'offset': value.offset,
        'limit': value.limit,
    };
}


